import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=c4bb3368&scoped=true"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureTable.vue?vue&type=style&index=0&id=c4bb3368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bb3368",
  null
  
)

export default component.exports